// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2tbFw","paramInput":"JobSimulator_paramInput__1DcuP","input":"JobSimulator_input__16WO0"};